const ID_TOKEN_KEY = "id_token";

import jwt_decode from "jwt-decode";

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const decodeToken = () => {
  return jwt_decode(window.localStorage.getItem(ID_TOKEN_KEY));
};

export default { getToken, saveToken, destroyToken, decodeToken };
